import Router from './util/Router'
import common from './routes/common'
import home from './routes/home'
import pageTemplateTeam from './routes/team'
import pageTemplateSafety from './routes/safety'
import pageTemplateFleet from './routes/fleet'
import newsPage from './routes/news'
import singlePost from './routes/singlePost'
import pageTemplateContact from './routes/contact'
import pageTemplateDefault from './routes/defaultPage'

/**
 * Populate Router instance with DOM routes
 * @type {Router} routes - An instance of our router
 */
const routes = new Router({
	/** All pages */
	common,
	/** Home page */
	home,
	/** About Us page, note the change from about-us to aboutUs. (camelCase.js) */
	pageTemplateTeam,
	/** Safety page */
	pageTemplateSafety,
	/** Fleet page */
	pageTemplateFleet,
	/** News page */
	newsPage,
	/** Single News page */
	singlePost,
	/** Contact page */
	pageTemplateContact,
	/** Default page */
	pageTemplateDefault,
})

/** Load Events */
routes.loadEvents()
